import React from 'react';
import { ITaskService } from '../../util/varibles/interface';

interface IProps {
    tasks: ITaskService[]
}

const TaskNoteDetail: React.FC<IProps> = ({ tasks }) => {
    const tasksWithNote = tasks.filter(({ note }) => note?.trim());

    if (tasksWithNote.length === 0)
        return null;

    return <div className={`flex-col !gap-1 z-[6] ml-[2px]`}>
        {tasksWithNote.map((task, index) => <div
            className='text-comment whitespace-pre-line leading-[22px]'
            key={`${task.group_id}-${index}`}
        >
            {task.note}
        </div>)}
    </div>;
};

export default TaskNoteDetail;
